import { render } from "./SettingCardItemControl.vue?vue&type=template&id=6033804e&scoped=true"
import script from "./SettingCardItemControl.vue?vue&type=script&lang=js"
export * from "./SettingCardItemControl.vue?vue&type=script&lang=js"

import "./SettingCardItemControl.vue?vue&type=style&index=0&id=6033804e&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6033804e"]])

export default __exports__